import { useEffect, useState } from "react";

import Days from "../../utils/constants/Days";

import "../../css/tablePage/TimeTable.css"
import proxy from "../../utils/Proxy";
import TimeTable from "./TimeTable";
import { getDateString } from "../../utils/Utils";
import LocationCode from "../../utils/constants/LocationCode";
import { useMediaQuery } from "react-responsive";
import MobileTable from "./MobileTable";
import TableLegend from "./TableLegend";
import LessonBannedModal from "../modal/LessonBannedModal";
import TeacherConstant from "../../utils/constants/TeacherConstant";

let getDailyTable = (tableData) => { // day=>[teacherid, ...]
    let ret = {
        "mon": [], "tue": [], "wed": [],
        "thu": [], "fri": [], "sat": [], "sun": []
    }
    for (let teacherid in tableData) {
        let days = tableData[teacherid].times;
        for (let day in days) {
            if (days[day].length !== 0)
                ret[day].push(parseInt(teacherid));
        }
    }
    return ret;
}

let TableContainer = (props) => {
    let [isLoaded, setIsLoaded] = useState(false);
    let [table, setTable] = useState(null)
    let [dailyTable, setDailyTable] = useState(null);
    let [lessons, setLessons] = useState(null)
    let [needUpdate, setNeedUpdate] = useState(true);
    let [bannedTimes, setBannedTimes] = useState(null);
    let [lessonBannedModalIsOpen, setLessonBannedModalIsOpen] = useState(false)
    let [lessonBannedModalData, setLessonBannedModalData] = useState({})

    let isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        if (props.location !== LocationCode.NOT_LOADING) {
            let requests = Promise.all([proxy.get("/api/tables?location=" + parseInt(props.location)),
            proxy.get("/api/lessons?start=" +
                getDateString(props.startDate) + "&end=" + getDateString(props.endDate) + "&location=" + parseInt(props.location)),
            proxy.get("/api/lessons/banned?start=" +
                getDateString(props.startDate) + "&end=" + getDateString(props.endDate))])

            requests.then(results => {
                let tableData = results[0].data.data
                setTable(tableData);
                setDailyTable(getDailyTable(tableData))

                let lessonData = results[1].data.data;
                setLessons(lessonData);

                let banned = results[2].data.data;
                setBannedTimes(banned);
                setNeedUpdate(false)
            })
        }
    }, [props.location, props.startDate, props.endDate, needUpdate])

    useEffect(() => {
        if (dailyTable !== null && lessons !== null) {
            setIsLoaded(true);
        }
    }, [dailyTable, lessons])

    let onClickLessonBannedModalOpen = async (date, day) => {
        setNeedUpdate(true)

        let teacherids = dailyTable[Days.keyset_render[day]]

        let teachersData = []

        for (let teacherid of teacherids) {
            let teacher = props.data.teachers[teacherid]

            teachersData.push({
                name: TeacherConstant.major_symbol[teacher.major] + teacher.name,
                teacherid: teacherid,
                enableTimes: table[teacherid].times[Days.keyset_render[day]]
            })
        }

        let transformedBannedTimes = {}
        let alreadyReservation = {}
        let bannedidMap = new Map()

        for (let teacherid of teacherids) {
            transformedBannedTimes[teacherid] = {}
            alreadyReservation[teacherid] = {}
            for (let time of Days.timeset) {
                transformedBannedTimes[teacherid][time] = false
                alreadyReservation[teacherid][time] = false
            }
        }
        for (let bannedTime of bannedTimes) {
            if (getDateString(new Date(bannedTime.date)) === getDateString(new Date(date)) && teacherids.includes(bannedTime.teacherid)) {
                transformedBannedTimes[bannedTime.teacherid][bannedTime.hour] = true
                bannedidMap.set(bannedTime.teacherid + ":" + bannedTime.hour, bannedTime.bannedid)
            }
        }
        let lessonResponse = await proxy.get("/api/lessons?start=" +
                getDateString(props.startDate) + "&end=" + getDateString(props.endDate) + "&location=" + parseInt(props.location))
        for (let lesson of lessonResponse.data.data) {
            if (getDateString(new Date(lesson.due)) === getDateString(new Date(date)) && teacherids.includes(lesson.teacherid))
                alreadyReservation[lesson.teacherid][lesson.hour] = true
        }
        setLessonBannedModalData({
            date: date,
            teachersData: teachersData,
            banned: transformedBannedTimes,
            alreadyReservation: alreadyReservation,
            bannedidMap: bannedidMap
        })

        setLessonBannedModalIsOpen(true)
    }

    let getDates = () => {
        let ret = [(
            lessonBannedModalIsOpen ?
                <LessonBannedModal
                    onCloseClick={() => setLessonBannedModalIsOpen(false)}
                    key="lesson-banned-modal"
                    data={lessonBannedModalData}
                    onSuccess={() => setNeedUpdate(true)}
                /> : null)];

        for (let i = 0; i < 7; i++) {
            let date = new Date(props.startDate)
            date.setDate(date.getDate() + i)
            let shortDateString = getDateString(date, true)
            let day = Days.korean[date.getDay()]
            
            if (props.isAdmin && getDateString(date) >= getDateString(new Date())) {
                ret.push(
                    <div className="table-date-item table-date-item-clickable" key={shortDateString}
                        onClick={() => onClickLessonBannedModalOpen(date, i)}
                        data-hover="레슨 시간 설정">
                        <p className="table-date">
                            {shortDateString + "(" + day + ")"}
                        </p>
                    </div>)
            }
            else {
                ret.push(
                    <div className="table-date-item" key={shortDateString}>
                        <p className="table-date">
                            {shortDateString + "(" + day + ")"}
                        </p>
                    </div>)
            }

        }
        return ret;
    }

    let getTimes = () => {
        let ret = [];
        let times = Days.timeset;
        for (let time of times) {
            let timeString = time + ":00";
            ret.push(
                <div className="table-sidebar-text-container" key={timeString}>
                    <p className="table-sidebar-text">{timeString}</p>
                </div>
            )
        }
        return ret;
    }

    return isMobile ? <MobileTable dailyTable={dailyTable} table={table} lessons={lessons}
        data={props.data} location={props.location} startDate={props.startDate}
        endDate={props.endDate} setNeedUpdate={setNeedUpdate.bind(this)}
        currentTeacher={props.currentTeacher} setNeedInfoRefresh={props.setNeedInfoRefresh}
        needUpdate={needUpdate} isAdmin={props.isAdmin} myInformation={props.myInformation}
        bannedTimes={bannedTimes} selectedDate={props.selectedDate} onChangeDate={props.onChangeDate}
    /> : (isLoaded ? (<>
        <TableLegend></TableLegend>
        <div className="table-container">
            <div className="top-table">
                <div className="table-date-item"></div>
                {getDates()}
            </div>
            <div className="mid-table">
                <div className="table-sidebar">
                    <div className="table-sidebar-text-container"></div>
                    {getTimes()}
                </div>
                <TimeTable dailyTable={dailyTable} table={table} lessons={lessons}
                    currentTeacher={props.currentTeacher} data={props.data}
                    location={props.location} startDate={props.startDate} endDate={props.endDate}
                    setNeedUpdate={setNeedUpdate.bind(this)} needUpdate={needUpdate}
                    setNeedInfoRefresh={props.setNeedInfoRefresh}
                    isAdmin={props.isAdmin} myInformation={props.myInformation}
                    bannedTimes={bannedTimes}
                ></TimeTable>
            </div>
        </div>
    </>) : null)
}
export default TableContainer;